var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-bg lanmu"},[_c('img',{attrs:{"src":_vm.img}}),_c('h1',[_c('router-link',{attrs:{"to":_vm.imgUrl}},[_vm._v(_vm._s(_vm.title))])],1),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }